import {Component, HostBinding, Input} from '@angular/core';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-error',
  template: `
    <div class="nns-wrapper" flex layout="row" layout-align="center start">
      <div class="nns-error-page-content" flex="none" layout="column" layout-align="center center" *ngIf="currentOrganization !== undefined">
        <div class="nns-error-page-type"
             *ngIf="errorTemplate == '404'"
        >404</div>
        <div class="nns-error-page-title"
             *ngIf="errorTemplate == '404'"
        >The page you are looking for can’t be found</div>

        <div class="nns-error-page-title"
          *ngIf="errorTemplate == '403'"
        >You don't have permission to access this page</div>
        <div class="nns-error-page-img"
          *ngIf="errorTemplate == '403'"
        >
          <img src="./dist/assets/403.png">
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      position:relative;
      box-sizing:border-box;
      padding:105px 0;
    }
    :host(.error-404) {
      padding: 0;
    }
    .nns-error-page-content {text-align:center;}
    nns-error-page .nns-wrapper {
      max-width:970px;
      min-width:320px;
      margin:0 auto;
      padding:0 10px;
    }
    .nns-error-page-type {
      font-weight:bold;
      font-size:235px;
      color:#EBEFF1;
      letter-spacing:-5.91px;
      line-height:1;
    }
    .nns-error-page-title {
      font-size:28px;
      color:#323348, 100%;
      padding:0 0 14px 0;
      line-height:1.3;
    }
    .nns-error-page-desc {
      font-size:18px;
      color:#2F3737;
    }
    .nns-error-page-img{
      max-width: 100%;
      margin-top: 80px;
    }
    .nns-error-page-img img{
      max-width: 100%;
    }
    @media only screen and (max-width: 768px) {

      .nns-error-page-type {
        font-size:150px;
        letter-spacing:-3.77px;
      }
      .nns-error-page-title {font-size:20px;}

    }
  `, `
    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
    :host-context(.nns-theme-night) .nns-error-page-title {
      color:rgba(255,255,255, 0.6);
    }
    :host-context(.nns-theme-night) .nns-error-page-desc {
      color:#fff;
    }
  `]
})
export class ErrorComponent {
  @Input() errorCode;
  @Input() currentOrganization;

  errorTemplates = {
    "403": "403",
    default: "404"
  };
  errorTemplate;
  fileUrl;

  constructor(
    public _config: Config,
  ) {
    this.errorTemplate = this.errorTemplates.default;
    this.fileUrl = this._config.get('BOX_URL') + '/file/';
  }

  ngOnChanges(changes) {
    if (this.errorTemplates[this.errorCode]) {
      this.errorTemplate = this.errorTemplates[this.errorCode];
    }
  }
}
